import { z } from 'zod';

/**
 * Wartelisten-Status Enum.
 * Workflow: waiting → offered → (accepted | expired)
 */
export const WaitlistStatusSchema = z.enum(['waiting', 'offered', 'accepted', 'expired']);

/** TypeScript Type für Wartelisten-Status */
export type WaitlistStatus = z.infer<typeof WaitlistStatusSchema>;

/**
 * Zod Schema für Waitlist — Runtime-Validierung + Type-Inference.
 * Warteliste — primär für ICON_LEAGUE Events mit begrenzten Tickets.
 */
export const WaitlistSchema = z.object({
  id: z.string().cuid(),
  eventId: z.string().cuid(),
  userId: z.string(),
  position: z.number().int().positive(),
  status: WaitlistStatusSchema.default('waiting'),
  offeredAt: z.coerce.date().nullable().optional(),
  expiresAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type Waitlist = z.infer<typeof WaitlistSchema>;

/**
 * Schema für Waitlist-Erstellung.
 */
export const CreateWaitlistSchema = WaitlistSchema.pick({
  eventId: true,
  userId: true,
  position: true,
  status: true,
});

/** TypeScript Type für Waitlist-Erstellung */
export type CreateWaitlist = z.infer<typeof CreateWaitlistSchema>;

/**
 * Schema für Waitlist-Update.
 * Alle Felder optional — PATCH-Semantik.
 */
export const UpdateWaitlistSchema = WaitlistSchema.pick({
  position: true,
  status: true,
  offeredAt: true,
  expiresAt: true,
}).partial();

/** TypeScript Type für Waitlist-Update */
export type UpdateWaitlist = z.infer<typeof UpdateWaitlistSchema>;
